module.exports = __webpack_public_path__ + "static/turtlewithoutlegemptyy_desktop-d649fce75f2801ea0bdc1dc3b2d985a4.png";